// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { StoneShapeFragmentDoc } from './stoneShape.fragment.generated';
import { AssetFragmentDoc } from '../../../fragments/asset.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from './stoneShapeTranslation.fragment.generated';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
import { StoneCutFragmentDoc } from './stoneCut.fragment.generated';
import { StoneCutTranslationFragmentDoc } from './stoneCutTranslation.fragment.generated';
import { StoneCrystalFragmentDoc } from './stoneCrystal.fragment.generated';
import { StoneCrystalTranslationFragmentDoc } from './stoneCrystalTranslation.fragment.generated';
import { StoneColorFragmentDoc } from '../../gems/fragments/StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from '../../gems/fragments/StoneColorTranslation.fragment.generated';
import { StoneGradeFragmentDoc } from './stoneGrade.fragment.generated';
import { StoneClarityFragmentDoc } from '../../gems/fragments/stoneClarity.fragment.generated';
import { ClarityTranslationFragmentDoc } from '../../gems/fragments/ClarityTranslation.fragment.generated';
import { NonSkuGemstoneImageFragmentDoc } from '../../../../../domain/stone/nonSkuGemstoneImage.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../../../components/monolithImageSize.fragment.generated';
export const NonSkuGemstoneFragmentDoc = `
    fragment nonSkuGemstone on NonSkuGemstone {
  __typename
  id
  shape {
    ...stoneShape
  }
  salePrice(currency: $currency, country: $country) {
    ...money
  }
  cut {
    ...stoneCut
  }
  caratWeight
  crystal {
    ...stoneCrystal
  }
  color {
    ...stoneColor
  }
  colorGrade {
    ...stoneGrade
  }
  clarity {
    ...stoneClarity
  }
  ...nonSkuGemstoneImage
}
    `;